import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Card,
  CardBody,
  Heading,
  VStack,
  useColorModeValue,
  Spinner,
  Center,
} from '@chakra-ui/react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {
  useGetHowToUseSection,
  useAddHowToUseSection,
  useUpdateHowToUseSection,
} from './hooks/useHowToUse';

const HowToUseApplication = () => {
  const [content, setContent] = useState('');
  const [existingId, setExistingId] = useState(null);

  const { data, isLoading, isFetching, refetch } = useGetHowToUseSection();
  const addMutation = useAddHowToUseSection({
    onSuccess: () => refetch(),
  });
  const updateMutation = useUpdateHowToUseSection({
    onSuccess: () => refetch(),
  });

  useEffect(() => {
    if (data?.data?.result) {
      setContent(data.data.result.description || '');
      setExistingId(data.data.result._id);
    }
  }, [data]);

  const handleSave = () => {
    if (existingId) {
      updateMutation.mutate({ id: existingId, description: content });
    } else {
      addMutation.mutate({ description: content });
    }
  };

  const cardBg = useColorModeValue('white', 'gray.800');
  const cardShadow = useColorModeValue(
    '0px 18px 40px rgba(112, 144, 176, 0.12)',
    'none',
  );

  const editorBorderColor = useColorModeValue('gray.200', 'gray.600');

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'image'],
      ['clean'],
    ],
  };

  if (isLoading) {
    return (
      <Center h="500px">
        <Spinner size="xl" color="blue.500" thickness="4px" />
      </Center>
    );
  }

  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }} px="25px">
      <Card bg={cardBg} boxShadow={cardShadow} borderRadius="20px" p="20px">
        <CardBody>
          <VStack spacing={6} align="stretch">
            <Heading size="md" mb={2}>
              How To Use Application Content
            </Heading>
            <Box
              borderRadius="15px"
              overflow="hidden"
              border="1px solid"
              borderColor={editorBorderColor}
            >
              <ReactQuill
                theme="snow"
                value={content}
                onChange={setContent}
                modules={modules}
                style={{ height: '400px', marginBottom: '45px' }}
              />
            </Box>
            <Box>
              <Button
                colorScheme="blue"
                onClick={handleSave}
                isLoading={addMutation.isPending || updateMutation.isPending}
                loadingText="Saving..."
                borderRadius="10px"
                size="lg"
                boxShadow="0px 4px 12px rgba(0, 0, 0, 0.1)"
                _hover={{ transform: 'translateY(-2px)' }}
                active={{ transform: 'translateY(0)' }}
              >
                {existingId ? 'Update Content' : 'Save Content'}
              </Button>
            </Box>
          </VStack>
        </CardBody>
      </Card>
    </Box>
  );
};

export default HowToUseApplication;
